import React, { Component } from 'react';

//import Descricao from './Descricao';
import Conteudo from '../../Conteudo';
import Perfil from '../../Perfil';
import Title from '../../components/Title';
import AuthProvider from '../../AuthProvider';
import PrincipaisSolicitacoes from './PrincipaisSolicitacoes';

export default class extends Component {
  render() {
    return (
      <div>
        <Title value="Diego Rivera" />
        <AuthProvider>
          {(_undefined, containsRole) => {
            let children = [];

            if (containsRole(['morador', 'agua-mineral'])) {
              children.push(PrincipaisSolicitacoes);
            }
            if (
              containsRole([
                'admin',
                'conselheiro',
                'sindico',
                'porteiro',
                'zelador',
                'morador',
                'proprietario'
              ])
            ) {
              children.push(Perfil);
            }

            return (
              children.length && (
                <Conteudo>
                  {children.map((Child, i) => (
                    <Child key={i} />
                  ))}
                </Conteudo>
              )
            );
          }}
        </AuthProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/inicio/Index.js